(function () {
  'use strict';

  function getRoot() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function getCartUrl() {
    return getRoot() + 'cart';
  }

  function goToCart() {
    window.location.assign(getCartUrl());
  }

  function initLuxProtectionPack() {
    document
      .querySelectorAll('[data-lux-protection-pack]')
      .forEach(function (pack) {
        if (pack.dataset.initialized === 'true') return;
        pack.dataset.initialized = 'true';

        var currentProductId = pack.getAttribute(
          'data-current-product-id'
        );

        var excludedProductIds = (
          pack.getAttribute('data-excluded-product-ids') || ''
        )
          .split(',')
          .map(function (id) {
            return String(id).trim();
          })
          .filter(Boolean);

        var currentVariantId = pack.getAttribute(
          'data-current-variant-id'
        );

        var mainProductPrice =
          parseInt(
            pack.getAttribute('data-current-product-price'),
            10
          ) || 0;

        var mainProductCompareAtPrice =
          parseInt(
            pack.getAttribute(
              'data-current-product-compare-at-price'
            ),
            10
          ) || 0;

        var moneyFormat =
          pack.getAttribute('data-money-format') || '{{amount}}€';

        var defaultPack = (
          pack.getAttribute('data-default-pack') || ''
        )
          .trim()
          .toLowerCase();

        var cards = Array.prototype.slice.call(
          pack.querySelectorAll('[data-pack-card]')
        );

        var cardsContainer = pack.querySelector(
          '.lux-protection-pack__cards'
        );

        var premiumCard = pack.querySelector(
          '[data-pack="premium"]'
        );

        var premiumOptions = Array.prototype.slice.call(
          pack.querySelectorAll('[data-premium-option]')
        );

        var premiumImage = pack.querySelector(
          '[data-premium-image]'
        );

        var premiumName = pack.querySelector(
          '[data-premium-name]'
        );

        var premiumPrice = pack.querySelector(
          '[data-premium-price]'
        );

        var premiumCompare = pack.querySelector(
          '[data-premium-compare]'
        );

        var totalEl = pack.querySelector(
          '[data-pack-total]'
        );

        var selectedTitleEl = pack.querySelector(
          '[data-selected-pack-title]'
        );

        var summaryEl = pack.querySelector(
          '[data-pack-summary]'
        );

        var summarySavingEl = pack.querySelector(
          '[data-pack-summary-saving]'
        );

        var addButton = pack.querySelector(
          '[data-pack-add]'
        );

        var messageEl = pack.querySelector(
          '[data-pack-message]'
        );

        var baseProductPriceEls =
          Array.prototype.slice.call(
            pack.querySelectorAll(
              '[data-base-product-price]'
            )
          );

        var baseProductCompareEls =
          Array.prototype.slice.call(
            pack.querySelectorAll(
              '[data-base-product-compare]'
            )
          );

        var variantsData = pack.querySelector(
          '[data-lux-product-variants]'
        );

        var popup = pack.querySelector(
          '[data-lux-upsell-popup]'
        );

        var popupDialog = pack.querySelector(
          '[data-upsell-dialog]'
        );

        var popupStatus = pack.querySelector(
          '[data-upsell-status]'
        );

        var popupProducts = pack.querySelector(
          '[data-upsell-products]'
        );

        var popupDismissButtons =
          pack.querySelectorAll(
            '[data-upsell-dismiss], [data-upsell-skip]'
          );

        if (
          !cards.length ||
          !addButton ||
          !popup ||
          !popupProducts
        ) {
          return;
        }

        /*
         * Movemos el drawer al body para evitar que el tema
         * limite el position: fixed dentro de la ficha.
         */
        if (popup.parentNode !== document.body) {
          document.body.appendChild(popup);
        }

        var currentVariantAvailable = true;
        var isSubmitting = false;
        var productVariants = [];

        try {
          productVariants = variantsData
            ? JSON.parse(variantsData.textContent)
            : [];
        } catch (error) {
          productVariants = [];
        }

        function formatMoney(cents) {
          if (
            window.Shopify &&
            typeof window.Shopify.formatMoney === 'function'
          ) {
            return window.Shopify.formatMoney(
              cents,
              moneyFormat
            );
          }

          return (cents / 100).toLocaleString('es-ES', {
            style: 'currency',
            currency: 'EUR'
          });
        }

        function intAttr(element, name) {
          return (
            parseInt(
              element.getAttribute(name),
              10
            ) || 0
          );
        }

        function getComparablePrice(
          compareAtPrice,
          price
        ) {
          compareAtPrice =
            parseInt(compareAtPrice, 10) || 0;

          price = parseInt(price, 10) || 0;

          return compareAtPrice > price
            ? compareAtPrice
            : price;
        }

        function getProductFormVariantId() {
          var productForms =
            Array.prototype.slice.call(
              document.querySelectorAll(
                'form[action*="/cart/add"]'
              )
            );

          var matchingForm = productForms.find(
            function (form) {
              return !form.closest(
                '[data-lux-protection-pack]'
              );
            }
          );

          var formVariantInput = matchingForm
            ? matchingForm.querySelector('[name="id"]')
            : null;

          if (
            formVariantInput &&
            formVariantInput.value
          ) {
            return formVariantInput.value;
          }

          return currentVariantId;
        }

        function getCurrentVariantData() {
          var variantId = String(
            getProductFormVariantId()
          );

          var variantData = productVariants.find(
            function (variant) {
              return String(variant.id) === variantId;
            }
          );

          return (
            variantData || {
              id: variantId,
              title: '',
              price: mainProductPrice,
              compare_at_price:
                mainProductCompareAtPrice,
              available: true
            }
          );
        }

        function clearMessage() {
          if (!messageEl) return;

          messageEl.textContent = '';

          messageEl.classList.remove(
            'is-error',
            'is-success'
          );
        }

        function setMessage(text, type) {
          if (!messageEl) return;

          messageEl.textContent = text;

          messageEl.classList.remove(
            'is-error',
            'is-success'
          );

          if (type) {
            messageEl.classList.add(
              'is-' + type
            );
          }
        }

        function getPackItems(card) {
          if (!card) return [];

          var screenId = card.getAttribute(
            'data-screen-id'
          );

          if (!screenId) return [];

          return [
            {
              id: Number(screenId),
              title:
                card.getAttribute(
                  'data-screen-title'
                ) || '',
              price: intAttr(
                card,
                'data-screen-price'
              ),
              compare: intAttr(
                card,
                'data-screen-compare'
              ),
              kind:
                card.getAttribute(
                  'data-screen-kind'
                ) || ''
            }
          ];
        }

        function calculateCardTotal(card) {
          var total = mainProductPrice;

          var compareTotal = getComparablePrice(
            mainProductCompareAtPrice,
            mainProductPrice
          );

          var items = getPackItems(card);

          items.forEach(function (item) {
            total += item.price;

            compareTotal += getComparablePrice(
              item.compare,
              item.price
            );
          });

          return {
            total: total,
            compareTotal: compareTotal,
            saving: Math.max(
              compareTotal - total,
              0
            ),
            items: items
          };
        }

        function updateCardPrice(card) {
          var priceEl = card.querySelector(
            '[data-pack-price]'
          );

          var savingEl = card.querySelector(
            '[data-pack-saving]'
          );

          var totals =
            calculateCardTotal(card);

          if (priceEl) {
            priceEl.textContent = formatMoney(
              totals.total
            );
          }

          if (savingEl) {
            savingEl.textContent =
              totals.saving > 0
                ? 'Ahorras ' +
                  formatMoney(totals.saving)
                : 'Protección opcional';
          }
        }

        function getSelectedCard() {
          return pack.querySelector(
            '[data-pack-card].is-selected'
          );
        }

        function updateCardStates() {
          cards.forEach(function (card) {
            var isSelected =
              card.classList.contains(
                'is-selected'
              );

            var actionEl = card.querySelector(
              '[data-pack-action]'
            );

            card.setAttribute(
              'aria-pressed',
              isSelected ? 'true' : 'false'
            );

            if (actionEl) {
              actionEl.textContent = isSelected
                ? 'Continuar sin protección'
                : 'Añadir protección';
            }
          });
        }

        function getSummaryTitle(card) {
          if (!card) {
            return 'Continuar sin protección';
          }

          var customTitle =
            card.getAttribute(
              'data-summary-title'
            );

          if (customTitle) {
            return customTitle;
          }

          return (
            card.getAttribute(
              'data-screen-kind'
            ) === 'privacy'
              ? 'Protección premium de privacidad'
              : 'Protección premium transparente'
          );
        }

        function getSummaryIncludes(card) {
          if (!card) {
            return (
              'Se añadirá únicamente el ' +
              'producto seleccionado.'
            );
          }

          return (
            card.getAttribute(
              'data-summary-copy'
            ) ||
            'Incluye este producto + protector de pantalla.'
          );
        }

        function updateSummary() {
          var selectedCard =
            getSelectedCard();

          if (!selectedCard) {
            if (selectedTitleEl) {
              selectedTitleEl.textContent =
                'Continuar sin protección';
            }

            if (totalEl) {
              totalEl.textContent =
                formatMoney(mainProductPrice);
            }

            if (summaryEl) {
              summaryEl.textContent =
                'Se añadirá únicamente el producto seleccionado.';
            }

            if (summarySavingEl) {
              summarySavingEl.textContent = '';
            }

            addButton.textContent =
              'Añadir sin protección';

            addButton.disabled =
              !currentVariantAvailable ||
              isSubmitting;

            updateCardStates();
            return;
          }

          var totals =
            calculateCardTotal(selectedCard);

          if (selectedTitleEl) {
            selectedTitleEl.textContent =
              getSummaryTitle(selectedCard);
          }

          if (totalEl) {
            totalEl.textContent =
              formatMoney(totals.total);
          }

          if (summaryEl) {
            summaryEl.textContent =
              getSummaryIncludes(selectedCard);
          }

          if (summarySavingEl) {
            summarySavingEl.textContent =
              totals.saving > 0
                ? 'Ahorras ' +
                  formatMoney(totals.saving) +
                  ' comprándolo junto.'
                : '';
          }

          addButton.textContent =
            'Añadir con protección';

          addButton.disabled =
            !currentVariantAvailable ||
            isSubmitting;

          updateCardStates();
        }

        function updateBaseProductPrices() {
          baseProductPriceEls.forEach(
            function (priceEl) {
              priceEl.textContent =
                formatMoney(mainProductPrice);
            }
          );

          baseProductCompareEls.forEach(
            function (compareEl) {
              var hasComparePrice =
                mainProductCompareAtPrice >
                mainProductPrice;

              compareEl.hidden =
                !hasComparePrice;

              compareEl.textContent =
                hasComparePrice
                  ? formatMoney(
                      mainProductCompareAtPrice
                    )
                  : '';
            }
          );
        }

        function updateAllTotals() {
          updateBaseProductPrices();

          cards.forEach(updateCardPrice);

          updateSummary();
        }

        function updateMainProduct() {
          var variant =
            getCurrentVariantData();

          currentVariantId = variant.id;

          mainProductPrice =
            parseInt(variant.price, 10) || 0;

          mainProductCompareAtPrice =
            parseInt(
              variant.compare_at_price,
              10
            ) || 0;

          currentVariantAvailable =
            variant.available !== false;

          updateAllTotals();
        }

        function selectOnlyCard(card) {
          if (!card) return;

          cards.forEach(
            function (otherCard) {
              otherCard.classList.remove(
                'is-selected'
              );
            }
          );

          card.classList.add('is-selected');

          updateSummary();
        }

        function togglePack(card) {
          if (!card || isSubmitting) return;

          clearMessage();

          var shouldDeselect =
            card.classList.contains(
              'is-selected'
            );

          cards.forEach(
            function (otherCard) {
              otherCard.classList.remove(
                'is-selected'
              );
            }
          );

          if (!shouldDeselect) {
            card.classList.add(
              'is-selected'
            );
          }

          updateSummary();
        }

        function applyPremiumOption(option) {
          if (
            !premiumCard ||
            !option ||
            isSubmitting
          ) {
            return;
          }

          premiumOptions.forEach(
            function (otherOption) {
              var isActive =
                otherOption === option;

              otherOption.classList.toggle(
                'is-active',
                isActive
              );

              otherOption.setAttribute(
                'aria-pressed',
                isActive ? 'true' : 'false'
              );
            }
          );

          var type =
            option.getAttribute(
              'data-option-type'
            ) || 'clear';

          var label =
            option.getAttribute(
              'data-option-label'
            ) || 'Transparente';

          var id =
            option.getAttribute(
              'data-option-id'
            ) || '';

          var title =
            option.getAttribute(
              'data-option-title'
            ) || '';

          var price =
            parseInt(
              option.getAttribute(
                'data-option-price'
              ),
              10
            ) || 0;

          var compare =
            parseInt(
              option.getAttribute(
                'data-option-compare'
              ),
              10
            ) || 0;

          var image =
            option.getAttribute(
              'data-option-image'
            ) || '';

          premiumCard.setAttribute(
            'data-screen-id',
            id
          );

          premiumCard.setAttribute(
            'data-screen-title',
            title
          );

          premiumCard.setAttribute(
            'data-screen-price',
            String(price)
          );

          premiumCard.setAttribute(
            'data-screen-compare',
            String(compare)
          );

          premiumCard.setAttribute(
            'data-screen-kind',
            type
          );

          if (premiumImage && image) {
            premiumImage.src = image;
            premiumImage.alt = title;
          }

          if (premiumName) {
            premiumName.textContent = label;
          }

          if (premiumPrice) {
            premiumPrice.textContent =
              formatMoney(price);
          }

          if (premiumCompare) {
            var hasCompare =
              compare > price;

            premiumCompare.hidden =
              !hasCompare;

            premiumCompare.textContent =
              hasCompare
                ? formatMoney(compare)
                : '';
          }

          selectOnlyCard(premiumCard);

          updateCardPrice(premiumCard);

          updateSummary();
        }

        function getDefaultCard() {
          if (!cards.length) return null;

          var exactMatch = cards.find(
            function (card) {
              return (
                (
                  card.getAttribute(
                    'data-pack'
                  ) || ''
                ).toLowerCase() ===
                defaultPack
              );
            }
          );

          if (exactMatch) {
            return exactMatch;
          }

          return (
            cards.find(function (card) {
              return (
                (
                  card.getAttribute(
                    'data-pack'
                  ) || ''
                ).toLowerCase() ===
                'premium'
              );
            }) || cards[0]
          );
        }

        function scrollCardIntoSnap(card) {
          if (!card || !cardsContainer) {
            return;
          }

          window.requestAnimationFrame(
            function () {
              window.requestAnimationFrame(
                function () {
                  if (
                    cardsContainer.scrollWidth <=
                    cardsContainer.clientWidth + 2
                  ) {
                    return;
                  }

                  var containerRect =
                    cardsContainer.getBoundingClientRect();

                  var cardRect =
                    card.getBoundingClientRect();

                  var cardLeftInsideContainer =
                    cardRect.left -
                    containerRect.left +
                    cardsContainer.scrollLeft;

                  var centeredLeft =
                    cardLeftInsideContainer -
                    (
                      cardsContainer.clientWidth -
                      card.offsetWidth
                    ) /
                      2;

                  var maxScrollLeft =
                    Math.max(
                      cardsContainer.scrollWidth -
                        cardsContainer.clientWidth,
                      0
                    );

                  var targetLeft =
                    Math.max(
                      0,
                      Math.min(
                        centeredLeft,
                        maxScrollLeft
                      )
                    );

                  cardsContainer.scrollTo({
                    left: targetLeft,
                    behavior: 'auto'
                  });
                }
              );
            }
          );
        }

        function selectDefaultPack() {
          var defaultCard =
            getDefaultCard();

          if (!defaultCard) return;

          cards.forEach(
            function (card) {
              card.classList.remove(
                'is-selected'
              );
            }
          );

          defaultCard.classList.add(
            'is-selected'
          );

          updateSummary();

          scrollCardIntoSnap(defaultCard);
        }

        function restoreButton() {
          isSubmitting = false;

          addButton.disabled =
            !currentVariantAvailable;

          addButton.textContent =
            getSelectedCard()
              ? 'Añadir con protección'
              : 'Añadir sin protección';
        }

        function dispatchCartEvents() {
          document.dispatchEvent(
            new CustomEvent('cart:refresh')
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );
        }

        function optimizeImageUrl(
          src,
          width
        ) {
          if (!src) return '';

          try {
            var url = new URL(
              src,
              window.location.origin
            );

            url.searchParams.set(
              'width',
              String(width || 420)
            );

            return url.toString();
          } catch (error) {
            return src;
          }
        }

        function getAvailableVariants(
          product
        ) {
          return (
            product.variants || []
          ).filter(function (variant) {
            return variant.available;
          });
        }

        function setPrice(
          priceBox,
          variant
        ) {
          priceBox.textContent = '';

          var strong =
            document.createElement('strong');

          strong.textContent = formatMoney(
            variant.price || 0
          );

          priceBox.appendChild(strong);

          if (
            variant.compare_at_price &&
            variant.compare_at_price >
              variant.price
          ) {
            var del =
              document.createElement('del');

            del.textContent = formatMoney(
              variant.compare_at_price
            );

            priceBox.insertBefore(
              del,
              strong
            );
          }
        }

        function addUpsellVariant(
          button,
          variantId,
          cardMessage
        ) {
          if (
            !variantId ||
            button.disabled
          ) {
            return;
          }

          button.disabled = true;
          button.textContent =
            'Añadiendo...';

          cardMessage.textContent = '';

          fetch(
            getRoot() + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1
                  }
                ]
              })
            }
          )
            .then(function (response) {
              if (!response.ok) {
                return response
                  .json()
                  .then(function (error) {
                    throw error;
                  });
              }

              return response.json();
            })
            .then(function () {
              dispatchCartEvents();
              goToCart();
            })
            .catch(function (error) {
              cardMessage.textContent =
                error &&
                error.description
                  ? error.description
                  : 'No se ha podido añadir este producto.';

              button.disabled = false;
              button.textContent =
                'Añadir';
            });
        }

        function createProductCard(
          product
        ) {
          var variants =
            getAvailableVariants(product);

          if (!variants.length) {
            return null;
          }

          var selectedVariant =
            variants[0];

          var article =
            document.createElement(
              'article'
            );

          article.className =
            'lux-upsell-product';

          var imageWrap =
            document.createElement('div');

          imageWrap.className =
            'lux-upsell-product__image';

          if (product.featured_image) {
            var image =
              document.createElement('img');

            image.src = optimizeImageUrl(
              product.featured_image,
              420
            );

            image.alt =
              product.title || '';

            image.width = 420;
            image.height = 420;
            image.loading = 'lazy';
            image.decoding = 'async';

            imageWrap.appendChild(image);
          }

          var body =
            document.createElement('div');

          body.className =
            'lux-upsell-product__body';

          var title =
            document.createElement('h4');

          title.className =
            'lux-upsell-product__title';

          title.textContent =
            product.title ||
            'Producto recomendado';

          body.appendChild(title);

          var price =
            document.createElement('div');

          price.className =
            'lux-upsell-product__price';

          if (variants.length > 1) {
            var select =
              document.createElement(
                'select'
              );

            select.className =
              'lux-upsell-product__variant';

            select.setAttribute(
              'aria-label',
              'Elige una opción'
            );

            variants.forEach(
              function (variant) {
                var option =
                  document.createElement(
                    'option'
                  );

                option.value =
                  variant.id;

                option.textContent =
                  (
                    variant.public_title ||
                    variant.title ||
                    'Opción'
                  ) +
                  ' · ' +
                  formatMoney(
                    variant.price || 0
                  );

                select.appendChild(
                  option
                );
              }
            );

            select.addEventListener(
              'change',
              function () {
                selectedVariant =
                  variants.find(
                    function (variant) {
                      return (
                        String(
                          variant.id
                        ) ===
                        String(
                          select.value
                        )
                      );
                    }
                  ) || variants[0];

                setPrice(
                  price,
                  selectedVariant
                );
              }
            );

            body.appendChild(select);
          }

          setPrice(
            price,
            selectedVariant
          );

          body.appendChild(price);

          var cardMessage =
            document.createElement('p');

          cardMessage.className =
            'lux-upsell-product__message';

          cardMessage.setAttribute(
            'aria-live',
            'polite'
          );

          var add =
            document.createElement(
              'button'
            );

          add.type = 'button';

          add.className =
            'lux-upsell-product__add';

          add.textContent = 'Añadir';

          add.addEventListener(
            'click',
            function () {
              addUpsellVariant(
                add,
                selectedVariant.id,
                cardMessage
              );
            }
          );

          body.appendChild(cardMessage);
          body.appendChild(add);

          article.appendChild(
            imageWrap
          );

          article.appendChild(body);

          return article;
        }

        function renderRecommendations(
          products
        ) {
          popupProducts.textContent = '';

          products.forEach(
            function (product) {
              var cardElement =
                createProductCard(
                  product
                );

              if (cardElement) {
                popupProducts.appendChild(
                  cardElement
                );
              }
            }
          );

          return (
            popupProducts.children.length
          );
        }

        function showPopup() {
          popup.hidden = false;

          popup.setAttribute(
            'aria-hidden',
            'false'
          );

          document.body.classList.add(
            'lux-upsell-open'
          );

          window.requestAnimationFrame(
            function () {
              if (popupDialog) {
                popupDialog.focus();
              }
            }
          );
        }

        function loadRecommendations() {
          if (!currentProductId) {
            goToCart();
            return;
          }

          /*
           * La popup permanece completamente oculta
           * hasta confirmar que hay recomendaciones.
           */
          popup.hidden = true;

          popup.setAttribute(
            'aria-hidden',
            'true'
          );

          if (popupStatus) {
            popupStatus.textContent = '';
          }

          popupProducts.textContent = '';

          var endpoint =
            getRoot() +
            'recommendations/products.json' +
            '?product_id=' +
            encodeURIComponent(
              currentProductId
            ) +
            '&limit=3' +
            '&intent=complementary';

          fetch(endpoint, {
            headers: {
              Accept: 'application/json'
            }
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error(
                  'Recommendations error'
                );
              }

              return response.json();
            })
            .then(function (data) {
              var products =
                (data.products || []).filter(
                  function (product) {
                    var id =
                      String(product.id);

                    return (
                      product.available &&
                      id !==
                        String(
                          currentProductId
                        ) &&
                      excludedProductIds.indexOf(
                        id
                      ) === -1 &&
                      getAvailableVariants(
                        product
                      ).length > 0
                    );
                  }
                );

              var count =
                renderRecommendations(
                  products.slice(0, 3)
                );

              /*
               * Si no hay productos complementarios,
               * no se abre nada y se va al carrito.
               */
              if (!count) {
                goToCart();
                return;
              }

              showPopup();
            })
            .catch(function () {
              goToCart();
            });
        }

        function addSelectionToCart() {
          if (isSubmitting) return;

          clearMessage();
          updateMainProduct();

          if (!currentVariantAvailable) {
            setMessage(
              'La variante seleccionada no está disponible ahora mismo.',
              'error'
            );

            return;
          }

          var selectedCard =
            getSelectedCard();

          var packItems =
            getPackItems(selectedCard);

          var items = [
            {
              id: Number(
                currentVariantId
              ),
              quantity: 1
            }
          ];

          packItems.forEach(
            function (item) {
              if (item.id) {
                items.push({
                  id: Number(item.id),
                  quantity: 1
                });
              }
            }
          );

          if (!items[0].id) {
            setMessage(
              'No se ha podido detectar la variante seleccionada.',
              'error'
            );

            return;
          }

          var isPackPurchase =
            Boolean(selectedCard);

          isSubmitting = true;

          addButton.disabled = true;

          addButton.textContent =
            'Añadiendo...';

          fetch(
            getRoot() + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: items
              })
            }
          )
            .then(function (response) {
              if (!response.ok) {
                return response
                  .json()
                  .then(function (error) {
                    throw error;
                  });
              }

              return response.json();
            })
            .then(function () {
              setMessage(
                isPackPurchase
                  ? 'Producto y protección añadidos al carrito.'
                  : 'Producto añadido sin protección.',
                'success'
              );

              dispatchCartEvents();

              loadRecommendations();
            })
            .catch(function (error) {
              setMessage(
                error &&
                error.description
                  ? error.description
                  : 'No se ha podido añadir la selección al carrito.',
                'error'
              );

              restoreButton();
            });
        }

        cards.forEach(function (card) {
          card.addEventListener(
            'click',
            function (event) {
              if (
                event.target.closest(
                  '[data-premium-option]'
                )
              ) {
                return;
              }

              togglePack(card);
            }
          );

          card.addEventListener(
            'keydown',
            function (event) {
              if (
                event.target.closest(
                  '[data-premium-option]'
                )
              ) {
                return;
              }

              if (
                event.key === 'Enter' ||
                event.key === ' '
              ) {
                event.preventDefault();
                togglePack(card);
              }
            }
          );
        });

        premiumOptions.forEach(
          function (option) {
            option.addEventListener(
              'click',
              function (event) {
                event.preventDefault();
                event.stopPropagation();

                clearMessage();

                applyPremiumOption(
                  option
                );
              }
            );
          }
        );

        addButton.addEventListener(
          'click',
          addSelectionToCart
        );

        popupDismissButtons.forEach(
          function (button) {
            button.addEventListener(
              'click',
              goToCart
            );
          }
        );

        popup.addEventListener(
          'keydown',
          function (event) {
            if (event.key === 'Escape') {
              event.preventDefault();
              goToCart();
            }
          }
        );

        document.addEventListener(
          'change',
          function (event) {
            if (
              event.target &&
              event.target.matches(
                'form[action*="/cart/add"] [name="id"]'
              )
            ) {
              window.setTimeout(
                updateMainProduct,
                50
              );
            }
          }
        );

        document.addEventListener(
          'variant:change',
          function () {
            window.setTimeout(
              updateMainProduct,
              50
            );
          }
        );

        var lastVariantId = String(
          getProductFormVariantId()
        );

        window.setInterval(
          function () {
            var nextVariantId = String(
              getProductFormVariantId()
            );

            if (
              nextVariantId !==
              lastVariantId
            ) {
              lastVariantId =
                nextVariantId;

              updateMainProduct();
            }
          },
          600
        );

        updateMainProduct();

        selectDefaultPack();
      });
  }

  if (window.LuxProtectionPackTorras) {
    window.LuxProtectionPackTorras.init();
    return;
  }

  window.LuxProtectionPackTorras = {
    init: initLuxProtectionPack
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initLuxProtectionPack
    );
  } else {
    initLuxProtectionPack();
  }

  document.addEventListener(
    'shopify:section:load',
    initLuxProtectionPack
  );
})();